import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ensureI18n } from "./i18n";

async function start() {
  await ensureI18n();
  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
start();
